module.exports = __webpack_public_path__ + "img/paws-legs.96977654.svg";